import { ICONS_ARRAY } from '../constants/likes';

export const useCountsData = (user) => {
  return (
    user &&
    ICONS_ARRAY.map((icon, i) => ({
      icon: `profile/${icon}`,
      index: user.likesCount[(++i).toString()] ?? 0,
      clickData: i,
    }))
  );
};
